import React, { useEffect } from "react";
import { CUSTOMER_TYPES } from "../../constants";


function CustomerCardHeader(props) {
    const { disabled, defaultValue } = props;

    // console.log("////////////CustomerCardHeader", props)

    const setTypology = (e) => {
        props.setType(e.target.options[e.target.selectedIndex].text);
    }

    useEffect(() => {
        if (defaultValue) props.setType(defaultValue);
    }, [])

    const renderTypes = () => (props?.types || CUSTOMER_TYPES).map((type => <option value={type}>{type}</option>))

    return (
        <div className="card-header border-0 p-0 mb-lg-30 m-0">
            <div className="d-flex">
                <h2 className="title-xxlarge mb-1">{props.customTitle || props.title}</h2>
            </div>
            <p className="subtitle-small mb-0">{props.description}</p>
            <br></br>
            {
                props.type &&
                <div className="select-wrapper mt-40 mb-3 mb-lg-30 bg-transparent p-0">
                    <label htmlFor="taxpayer-type">Tipologia*</label>
                    <select
                        onChange={!disabled ? setTypology : () => { }}
                        disabled={disabled}
                        id="taxpayer-type"
                        className={`bg-transparent ${disabled ? "disabled" : ""}`}
                        required
                        defaultValue={defaultValue || 'default'}>
                        <option value="default" disabled>Seleziona opzione</option>
                        {renderTypes()}
                    </select>
                </div>
            }
        </div>
    )
}


export default CustomerCardHeader;